import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { fetchPosts } from '../../redux/slices/Blog/blogSlice';
import { Helmet } from 'react-helmet-async';

const BlogList = () => {
  const { t, i18n } = useTranslation('common');
  const dispatch = useDispatch();
  const { posts, isLoading } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(fetchPosts(i18n.language));
  }, [dispatch, i18n.language]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{t('blog.title')} | Hotel Macarios</title>
        <meta name="description" content={t('blog.description')} />
        <link rel="canonical" href="https://www.hotelmacarios.com.mx/blog" />
      </Helmet>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <h1 className="font-['Fraunces'] text-4xl font-semibold text-gray-800 mb-2">{t('blog.title')}</h1>
        <p className="text-gray-500 mb-8">{t('blog.subtitle')}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {posts.map((post) => (
            <div key={post._id} className="group bg-white rounded-3xl shadow-md overflow-hidden hover:shadow-lg transition">
              {post.image && (
                <Link to={`/blog/${post.slug}`} className="block overflow-hidden">
                  <img src={post.image} alt={post.title} loading="lazy" className="w-full aspect-[4/3] md:aspect-[16/10] object-cover transition-transform duration-500 group-hover:scale-105" />
                </Link>
              )}
              <div className="p-5">
                <h2 className="font-['Fraunces'] text-2xl md:text-xl font-semibold text-gray-800 mb-2">
                  <Link to={`/blog/${post.slug}`} className="hover:text-red-600">{post.title}</Link>
                </h2>
                <p className="text-gray-500 text-sm mb-3">{new Date(post.publishedAt).toLocaleDateString()}</p>
                <p className="text-gray-600 line-clamp-3">{post.content.substring(0, 150)}…</p>
                <Link to={`/blog/${post.slug}`} className="inline-block mt-3 text-red-600 hover:underline">Read more →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default BlogList;